import React from 'react';
import {Link} from 'react-router-dom'

class SidebarLoginActions extends React.Component {
	render() {

		const collapsed = (this.props.collapsed === true)

		const projecst_list_title = collapsed ? 'Projects List' : ""
		const add_new_project_title = collapsed ? 'Add New Project' : ""
		const archive_title = collapsed ? 'Archive' : ""

		return (
			<div className="login-actions">
			<Link to="/" className="btn red darken-1 waves-effect waves-light" title={projecst_list_title}>
			<i className="material-icons white-text secondary-content">list</i> Projects List
			</Link>
			<Link to="/projects/new" className="btn red darken-1 waves-effect waves-light" title={add_new_project_title}>
			<i className="material-icons white-text secondary-content">library_add</i> Add New Project
			</Link>
			<Link to="/projects/archive" className="btn red darken-1 waves-effect waves-light" title={archive_title}>
			<i className="material-icons white-text secondary-content">delete</i> Archive
			</Link>
			</div>
		)
		
	}

}

export default SidebarLoginActions;



// WEBPACK FOOTER //
// ./src/js/components/SidebarLoginActions.js